exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-106c86ed]{margin:30px}.dashboard-text[data-v-106c86ed]{font-size:26px;line-height:46px}.dashboard-container[data-v-106c86ed]{padding:30px 0 0 30px}.dashboard-text[data-v-106c86ed]{text-align:center}", ""]);

// exports
